module.exports = __webpack_public_path__ + "static/img/time-remain-desc.fcc91ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/Play/img/record/time-remain-desc.png
// module id = 179
// module chunks = 0